export const DEFAULT_PROFILE_IMG = "/assets/images/avatar.png";
export const languages = [
  { id: "0", name: "English" },
  { id: "1", name: "French" }
];
export const NUM_OF_COMP_QUESTIONS = 10;
export const COMP_QUESTIONS_POINTS = 1;
